const a = {
  addToFolder: () => import("./index.es28.js"),
  addedtoFolder: () => import("./index.es29.js"),
  alarmBell: () => import("./index.es30.js"),
  alignBottom: () => import("./index.es31.js"),
  alignCenter: () => import("./index.es32.js"),
  alignLeft: () => import("./index.es33.js"),
  alignMiddle: () => import("./index.es34.js"),
  alignRight: () => import("./index.es35.js"),
  alignTop: () => import("./index.es36.js"),
  amex: () => import("./index.es37.js"),
  applePay: () => import("./index.es38.js"),
  arrowBack: () => import("./index.es39.js"),
  arrowCursorBlue: () => import("./index.es40.js"),
  arrowCursorPink: () => import("./index.es41.js"),
  arrowCursorYellow: () => import("./index.es42.js"),
  arrowDown: () => import("./index.es43.js"),
  arrowRight: () => import("./index.es44.js"),
  arrowUp: () => import("./index.es45.js"),
  attachment: () => import("./index.es46.js"),
  audioModified: () => import("./index.es47.js"),
  blankCalendarBlue: () => import("./index.es48.js"),
  blankCalendarPink: () => import("./index.es49.js"),
  blankCalendarYellow: () => import("./index.es50.js"),
  brain: () => import("./index.es51.js"),
  businessStartupBlue: () => import("./index.es52.js"),
  businessStartupPink: () => import("./index.es53.js"),
  businessStartupYellow: () => import("./index.es54.js"),
  calendar: () => import("./index.es55.js"),
  cameraBlue: () => import("./index.es56.js"),
  cameraPink: () => import("./index.es57.js"),
  cameraYellow: () => import("./index.es58.js"),
  cameraVideoBlue: () => import("./index.es59.js"),
  cameraVideoPink: () => import("./index.es60.js"),
  cameraVideoYellow: () => import("./index.es61.js"),
  chatBubbleTypingOvalBlue: () => import("./index.es62.js"),
  chatBubbleTypingOvalPink: () => import("./index.es63.js"),
  chatBubbleTypingOvalYellow: () => import("./index.es64.js"),
  chatTwoBubblesSquareBlue: () => import("./index.es65.js"),
  chatTwoBubblesSquarePink: () => import("./index.es66.js"),
  chatTwoBubblesSquareYellow: () => import("./index.es67.js"),
  check: () => import("./index.es68.js"),
  checkCircle: () => import("./index.es69.js"),
  chevronDown: () => import("./index.es70.js"),
  chevronLeft: () => import("./index.es71.js"),
  chevronRight: () => import("./index.es72.js"),
  chevronUp: () => import("./index.es73.js"),
  circleClockBlue: () => import("./index.es74.js"),
  circleClockPink: () => import("./index.es75.js"),
  circleClockYellow: () => import("./index.es76.js"),
  close: () => import("./index.es77.js"),
  cog: () => import("./index.es78.js"),
  compass: () => import("./index.es79.js"),
  controlsForward: () => import("./index.es80.js"),
  controlsPause: () => import("./index.es81.js"),
  controlsPlay: () => import("./index.es82.js"),
  controlsRecord: () => import("./index.es83.js"),
  controlsRewind: () => import("./index.es84.js"),
  controlsStop: () => import("./index.es85.js"),
  dashboardGaugeBlue: () => import("./index.es86.js"),
  dashboardGaugePink: () => import("./index.es87.js"),
  dashboardGaugeYellow: () => import("./index.es88.js"),
  dinersClub: () => import("./index.es89.js"),
  discover: () => import("./index.es90.js"),
  downloadBottom: () => import("./index.es91.js"),
  downloadSquareBlue: () => import("./index.es92.js"),
  downloadSquarePink: () => import("./index.es93.js"),
  downloadSquareYellow: () => import("./index.es94.js"),
  dropbox: () => import("./index.es95.js"),
  emptyClipboardBlue: () => import("./index.es96.js"),
  emptyClipboardPink: () => import("./index.es97.js"),
  emptyClipboardYellow: () => import("./index.es98.js"),
  erlenmeyerFlaskBlue: () => import("./index.es99.js"),
  erlenmeyerFlaskPink: () => import("./index.es100.js"),
  erlenmeyerFlaskYellow: () => import("./index.es101.js"),
  error: () => import("./index.es102.js"),
  expandHorizontal: () => import("./index.es103.js"),
  expandVertical: () => import("./index.es104.js"),
  facebook: () => import("./index.es105.js"),
  favorite: () => import("./index.es106.js"),
  favoriteFilled: () => import("./index.es107.js"),
  fileDouble: () => import("./index.es108.js"),
  filter: () => import("./index.es109.js"),
  filterImage: () => import("./index.es110.js"),
  filterMusic: () => import("./index.es111.js"),
  filterPlus: () => import("./index.es112.js"),
  filterVideo: () => import("./index.es113.js"),
  folderStar: () => import("./index.es114.js"),
  gitHub: () => import("./index.es115.js"),
  googlePay: () => import("./index.es116.js"),
  graphPieChartBlue: () => import("./index.es117.js"),
  graphPieChartPink: () => import("./index.es118.js"),
  graphPieChartYellow: () => import("./index.es119.js"),
  gridRulesBlue: () => import("./index.es120.js"),
  gridRulesPink: () => import("./index.es121.js"),
  gridRulesYellow: () => import("./index.es122.js"),
  happyFaceBlue: () => import("./index.es123.js"),
  happyFacePink: () => import("./index.es124.js"),
  happyFaceYellow: () => import("./index.es125.js"),
  headphonesCustomer: () => import("./index.es126.js"),
  helpChatBlue: () => import("./index.es127.js"),
  helpChatPink: () => import("./index.es128.js"),
  helpChatYellow: () => import("./index.es129.js"),
  homeBlue: () => import("./index.es130.js"),
  homePink: () => import("./index.es131.js"),
  homeYellow: () => import("./index.es132.js"),
  hourGlassBlue: () => import("./index.es133.js"),
  hourGlassPink: () => import("./index.es134.js"),
  hourGlassYellow: () => import("./index.es135.js"),
  house: () => import("./index.es136.js"),
  imageModified: () => import("./index.es137.js"),
  informationCircle: () => import("./index.es138.js"),
  informationCircleInverted: () => import("./index.es139.js"),
  instagram: () => import("./index.es140.js"),
  interfaceAlertAlarmBellBlue: () => import("./index.es141.js"),
  interfaceAlertAlarmBellPink: () => import("./index.es142.js"),
  interfaceAlertAlarmBellYellow: () => import("./index.es143.js"),
  interfaceAwardTrophyBlue: () => import("./index.es144.js"),
  interfaceAwardTrophyPink: () => import("./index.es145.js"),
  interfaceAwardTrophyYellow: () => import("./index.es146.js"),
  interfaceCursorArrowBlue: () => import("./index.es147.js"),
  interfaceCursorArrowPink: () => import("./index.es148.js"),
  interfaceCursorArrowYellow: () => import("./index.es149.js"),
  interfaceFavoriteLikeBlue: () => import("./index.es150.js"),
  interfaceFavoriteLikePink: () => import("./index.es151.js"),
  interfaceFavoriteLikeYellow: () => import("./index.es152.js"),
  interfaceImageVideoAudioSubtitlesBlue: () => import("./index.es153.js"),
  interfaceImageVideoAudioSubtitlesPink: () => import("./index.es154.js"),
  interfaceImageVideoAudioSubtitlesYellow: () => import("./index.es155.js"),
  interfaceLightingLightBulbBlue: () => import("./index.es156.js"),
  interfaceLightingLightBulbPink: () => import("./index.es157.js"),
  interfaceLightingLightBulbYellow: () => import("./index.es158.js"),
  interfaceSearchBlue: () => import("./index.es159.js"),
  interfaceSearchPink: () => import("./index.es160.js"),
  interfaceSearchYellow: () => import("./index.es161.js"),
  keyboardBlue: () => import("./index.es162.js"),
  keyboardPink: () => import("./index.es163.js"),
  keyboardYellow: () => import("./index.es164.js"),
  keyboardArrowRight: () => import("./index.es165.js"),
  layersBlue: () => import("./index.es166.js"),
  layersPink: () => import("./index.es167.js"),
  layersYellow: () => import("./index.es168.js"),
  layoutWindowBlue: () => import("./index.es169.js"),
  layoutWindowPink: () => import("./index.es170.js"),
  layoutWindowYellow: () => import("./index.es171.js"),
  linkedIn: () => import("./index.es172.js"),
  lock: () => import("./index.es173.js"),
  lockUnlock: () => import("./index.es174.js"),
  loginBlue: () => import("./index.es175.js"),
  loginPink: () => import("./index.es176.js"),
  loginYellow: () => import("./index.es177.js"),
  logoStoryblocks: () => import("./index.es178.js"),
  logoStoryblocksGray: () => import("./index.es179.js"),
  logoStoryblocksWhite: () => import("./index.es180.js"),
  maestro: () => import("./index.es181.js"),
  magicWandBlue: () => import("./index.es182.js"),
  magicWandPink: () => import("./index.es183.js"),
  magicWandYellow: () => import("./index.es184.js"),
  maker: () => import("./index.es185.js"),
  mastercard: () => import("./index.es186.js"),
  megaphoneBlue: () => import("./index.es187.js"),
  megaphonePink: () => import("./index.es188.js"),
  megaphoneYellow: () => import("./index.es189.js"),
  microphone: () => import("./index.es190.js"),
  microphoneOff: () => import("./index.es191.js"),
  moneyCashBillBlue: () => import("./index.es192.js"),
  moneyCashBillPink: () => import("./index.es193.js"),
  moneyCashBillYellow: () => import("./index.es194.js"),
  moneyWalletBlue: () => import("./index.es195.js"),
  moneyWalletPink: () => import("./index.es196.js"),
  moneyWalletYellow: () => import("./index.es197.js"),
  musicSound: () => import("./index.es198.js"),
  navigationMenuHorizontal: () => import("./index.es199.js"),
  navigationMenuVertical: () => import("./index.es200.js"),
  newStickyNoteBlue: () => import("./index.es201.js"),
  newStickyNotePink: () => import("./index.es202.js"),
  newStickyNoteYellow: () => import("./index.es203.js"),
  oneFingerTapBlue: () => import("./index.es204.js"),
  oneFingerTapPink: () => import("./index.es205.js"),
  oneFingerTapYellow: () => import("./index.es206.js"),
  openBookBlue: () => import("./index.es207.js"),
  openBookPink: () => import("./index.es208.js"),
  openBookYellow: () => import("./index.es209.js"),
  panelCollapse: () => import("./index.es210.js"),
  panelExpand: () => import("./index.es211.js"),
  paragraphLeftAlign: () => import("./index.es212.js"),
  paragraphsCenterAlign: () => import("./index.es213.js"),
  paragraphsRightAlign: () => import("./index.es214.js"),
  payPal: () => import("./index.es215.js"),
  penBlue: () => import("./index.es216.js"),
  penPink: () => import("./index.es217.js"),
  penYellow: () => import("./index.es218.js"),
  pencil: () => import("./index.es219.js"),
  picturesFolderMemoriesBlue: () => import("./index.es220.js"),
  picturesFolderMemoriesPink: () => import("./index.es221.js"),
  picturesFolderMemoriesYellow: () => import("./index.es222.js"),
  pinBlue: () => import("./index.es223.js"),
  pinPink: () => import("./index.es224.js"),
  pinYellow: () => import("./index.es225.js"),
  pinterest: () => import("./index.es226.js"),
  playListBlue: () => import("./index.es227.js"),
  playListPink: () => import("./index.es228.js"),
  playListYellow: () => import("./index.es229.js"),
  playVideo: () => import("./index.es230.js"),
  plus: () => import("./index.es231.js"),
  profileAvatar: () => import("./index.es232.js"),
  questionmark: () => import("./index.es233.js"),
  refresh: () => import("./index.es234.js"),
  screenTvBlue: () => import("./index.es235.js"),
  screenTvPink: () => import("./index.es236.js"),
  screenTvYellow: () => import("./index.es237.js"),
  scriptBlue: () => import("./index.es238.js"),
  scriptPink: () => import("./index.es239.js"),
  scriptYellow: () => import("./index.es240.js"),
  search: () => import("./index.es241.js"),
  searchSimilar: () => import("./index.es242.js"),
  settingMenu: () => import("./index.es243.js"),
  share: () => import("./index.es244.js"),
  shoppingCartBlue: () => import("./index.es245.js"),
  shoppingCartPink: () => import("./index.es246.js"),
  shoppingCartYellow: () => import("./index.es247.js"),
  snapchat: () => import("./index.es248.js"),
  stamp: () => import("./index.es249.js"),
  starFourSided: () => import("./index.es250.js"),
  stopwatchBlue: () => import("./index.es251.js"),
  stopwatchPink: () => import("./index.es252.js"),
  stopwatchYellow: () => import("./index.es253.js"),
  stripe: () => import("./index.es254.js"),
  sunCloudBlue: () => import("./index.es255.js"),
  sunCloudPink: () => import("./index.es256.js"),
  sunCloudYellow: () => import("./index.es257.js"),
  textBold: () => import("./index.es258.js"),
  textInputArea: () => import("./index.es259.js"),
  textItalic: () => import("./index.es260.js"),
  textStrikeThrough: () => import("./index.es261.js"),
  textStyle: () => import("./index.es262.js"),
  textUnderline: () => import("./index.es263.js"),
  thirdEye: () => import("./index.es264.js"),
  trash: () => import("./index.es265.js"),
  travelMapEarthBlue: () => import("./index.es266.js"),
  travelMapEarthPink: () => import("./index.es267.js"),
  travelMapEarthYellow: () => import("./index.es268.js"),
  twitter: () => import("./index.es269.js"),
  uploadBottom: () => import("./index.es270.js"),
  uploadCircleBlue: () => import("./index.es271.js"),
  uploadCirclePink: () => import("./index.es272.js"),
  uploadCircleYellow: () => import("./index.es273.js"),
  userCircleSingleBlue: () => import("./index.es274.js"),
  userCircleSinglePink: () => import("./index.es275.js"),
  userCircleSingleYellow: () => import("./index.es276.js"),
  userSingleBlue: () => import("./index.es277.js"),
  userSinglePink: () => import("./index.es278.js"),
  userSingleYellow: () => import("./index.es279.js"),
  venmo: () => import("./index.es280.js"),
  verticalSliderSquareBlue: () => import("./index.es281.js"),
  verticalSliderSquarePink: () => import("./index.es282.js"),
  verticalSliderSquareYellow: () => import("./index.es283.js"),
  videoEditPeel: () => import("./index.es284.js"),
  videoEditSplit: () => import("./index.es285.js"),
  videoModified: () => import("./index.es286.js"),
  view: () => import("./index.es287.js"),
  viewOff: () => import("./index.es288.js"),
  visa: () => import("./index.es289.js"),
  voiceMailBlue: () => import("./index.es290.js"),
  voiceMailPink: () => import("./index.es291.js"),
  voiceMailYellow: () => import("./index.es292.js"),
  volumeDown: () => import("./index.es293.js"),
  volumeLevelHighBlue: () => import("./index.es294.js"),
  volumeLevelHighPink: () => import("./index.es295.js"),
  volumeLevelHighYellow: () => import("./index.es296.js"),
  volumeMedium: () => import("./index.es297.js"),
  volumeOff: () => import("./index.es298.js"),
  volumeUp: () => import("./index.es299.js"),
  warningTriangle: () => import("./index.es300.js"),
  webcamVideoBlue: () => import("./index.es301.js"),
  webcamVideoPink: () => import("./index.es302.js"),
  webcamVideoYellow: () => import("./index.es303.js"),
  youtube: () => import("./index.es304.js")
}, t = /* @__PURE__ */ new Set([
  "arrowCursor",
  "blankCalendar",
  "businessStartup",
  "camera",
  "cameraVideo",
  "chatBubbleTypingOval",
  "chatTwoBubblesSquare",
  "circleClock",
  "dashboardGauge",
  "downloadSquare",
  "emptyClipboard",
  "erlenmeyerFlask",
  "graphPieChart",
  "gridRules",
  "happyFace",
  "helpChat",
  "home",
  "hourGlass",
  "interfaceAlertAlarmBell",
  "interfaceAwardTrophy",
  "interfaceCursorArrow",
  "interfaceFavoriteLike",
  "interfaceImageVideoAudioSubtitles",
  "interfaceLightingLightBulb",
  "interfaceSearch",
  "keyboard",
  "layers",
  "layoutWindow",
  "login",
  "magicWand",
  "megaphone",
  "moneyCashBill",
  "moneyWallet",
  "newStickyNote",
  "oneFingerTap",
  "openBook",
  "pen",
  "picturesFolderMemories",
  "pin",
  "playList",
  "screenTv",
  "script",
  "shoppingCart",
  "stopwatch",
  "sunCloud",
  "travelMapEarth",
  "uploadCircle",
  "userCircleSingle",
  "userSingle",
  "verticalSliderSquare",
  "voiceMail",
  "volumeLevelHigh",
  "webcamVideo"
]), p = {
  arrowCursor: ["blue", "pink", "yellow"],
  blankCalendar: ["blue", "pink", "yellow"],
  businessStartup: ["blue", "pink", "yellow"],
  camera: ["blue", "pink", "yellow"],
  cameraVideo: ["blue", "pink", "yellow"],
  chatBubbleTypingOval: ["blue", "pink", "yellow"],
  chatTwoBubblesSquare: ["blue", "pink", "yellow"],
  circleClock: ["blue", "pink", "yellow"],
  dashboardGauge: ["blue", "pink", "yellow"],
  downloadSquare: ["blue", "pink", "yellow"],
  emptyClipboard: ["blue", "pink", "yellow"],
  erlenmeyerFlask: ["blue", "pink", "yellow"],
  graphPieChart: ["blue", "pink", "yellow"],
  gridRules: ["blue", "pink", "yellow"],
  happyFace: ["blue", "pink", "yellow"],
  helpChat: ["blue", "pink", "yellow"],
  home: ["blue", "pink", "yellow"],
  hourGlass: ["blue", "pink", "yellow"],
  interfaceAlertAlarmBell: ["blue", "pink", "yellow"],
  interfaceAwardTrophy: ["blue", "pink", "yellow"],
  interfaceCursorArrow: ["blue", "pink", "yellow"],
  interfaceFavoriteLike: ["blue", "pink", "yellow"],
  interfaceImageVideoAudioSubtitles: ["blue", "pink", "yellow"],
  interfaceLightingLightBulb: ["blue", "pink", "yellow"],
  interfaceSearch: ["blue", "pink", "yellow"],
  keyboard: ["blue", "pink", "yellow"],
  layers: ["blue", "pink", "yellow"],
  layoutWindow: ["blue", "pink", "yellow"],
  login: ["blue", "pink", "yellow"],
  magicWand: ["blue", "pink", "yellow"],
  megaphone: ["blue", "pink", "yellow"],
  moneyCashBill: ["blue", "pink", "yellow"],
  moneyWallet: ["blue", "pink", "yellow"],
  newStickyNote: ["blue", "pink", "yellow"],
  oneFingerTap: ["blue", "pink", "yellow"],
  openBook: ["blue", "pink", "yellow"],
  pen: ["blue", "pink", "yellow"],
  picturesFolderMemories: ["blue", "pink", "yellow"],
  pin: ["blue", "pink", "yellow"],
  playList: ["blue", "pink", "yellow"],
  screenTv: ["blue", "pink", "yellow"],
  script: ["blue", "pink", "yellow"],
  shoppingCart: ["blue", "pink", "yellow"],
  stopwatch: ["blue", "pink", "yellow"],
  sunCloud: ["blue", "pink", "yellow"],
  travelMapEarth: ["blue", "pink", "yellow"],
  uploadCircle: ["blue", "pink", "yellow"],
  userCircleSingle: ["blue", "pink", "yellow"],
  userSingle: ["blue", "pink", "yellow"],
  verticalSliderSquare: ["blue", "pink", "yellow"],
  voiceMail: ["blue", "pink", "yellow"],
  volumeLevelHigh: ["blue", "pink", "yellow"],
  webcamVideo: ["blue", "pink", "yellow"]
};
function m(e, o) {
  let r = e;
  if (t.has(e)) {
    const i = p[e] || [], l = o || i[0];
    if (o && !i.includes(o))
      return console.error(
        'Invalid variant "' + o + '" for icon "' + e + '". Available variants: ' + i.join(", ")
      ), null;
    r = e + l.charAt(0).toUpperCase() + l.slice(1);
  } else o && console.warn('Icon "' + e + '" does not support variants. Ignoring variant "' + o + '".');
  return a[r] || null;
}
function n(e) {
  return t.has(e);
}
function u(e) {
  const o = p[e];
  return o ? o[0] : void 0;
}
export {
  u as getDefaultVariant,
  m as getIconImport,
  n as hasVariants
};
